<template>
    <div class="bottom_nav_box" v-if="display">
        525455
        <div class="contact_title">联系我们</div>
        <div class="contact_content">
            <div class="content_font">拉萨总部：拉萨经济技术开发区工业中心2期</div>
            <div class="content_font">联系电话：17354516359</div>
            <div class="content_font">电子邮箱：service@xzjxrl.com</div>
            <div class="content_font">企业微信：17354516359</div>
        </div>
        <div class="filing_box">
            <div>版权所有：西藏婧贤人力资源管理有限公司</div>
            <a :href="'http://'+'beian.miit.gov.cn/'" target="_blank">藏 ICP 备 2025003038 号-1</a>
            <div class="nat_box">
                <img class="nat_img_box" src="../../../assets/icons/官网首页_slices/national.png" alt="">
                <a href="https://beian.mps.gov.cn/#/query/webSearch?code=54010002000200" rel="noreferrer" target="_blank">藏公网安备54010002000200号</a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['display'],
    data(){
        return{

        }
    },
    created(){
        // console.log(1111,this.display);
        
    },
}
</script>
<style lang="less" scoped>
    .bottom_nav_box{
        background: #1B1E2D;
        .contact_title{
            color: #fff;
            font-weight: 500;
            font-size: 36px;
            padding-top: 30px;
            padding-left: 35px;
            padding-bottom: 20px;
            box-sizing: border-box;
        }
        .contact_content{
            font-size: 32px;
            color: #fff;
            padding-left: 35px;
            box-sizing: border-box;
            .content_font{
                box-sizing: border-box;
                padding-bottom: 20px;
            }
        }
        .filing_box{
            color:#909090;
            font-size: 22px;
            margin-top: 40px;
            padding-bottom: 45px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            a{
                color:#909090;
                text-decoration: none;
            }
            .nat_box{
                display: flex;
                align-items: center;
                .nat_img_box{
                    width: 22px;
                    height: 22px;
                    margin-right: 5px;
                }
            }
        }
    }

</style>
